module.exports = __webpack_public_path__ + "static/3-bee8c53ada55d47a371fe98a2f118815.png";